.empty {
  margin: 0;
  color: var(--color-muted);
  font-size: 0.8125rem;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2rem;
  padding-block: 0.125rem;
  padding-inline: 0.5rem 0.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-card);
  font-size: 0.8125rem;
}

.step[aria-pressed="true"] {
  border-color: var(--color-primary);
  background: var(--color-primary-soft);
}

button.step {
  cursor: pointer;

  &:hover { background: var(--color-surface-raised); }
  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
}

.stepNumber {
  display: grid;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  place-items: center;
  border-radius: 50%;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 0.6875rem;
  font-weight: 600;
}

.stepIcon {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  color: var(--color-primary);

  svg {
    width: 1rem;
    height: 1rem;
  }
}

.stepLabel,
.stepCode {
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
}

.stepLabel {
  font-weight: 500;
}

// A step the rows have no value for: shown as the options it holds.
.stepCode {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 0.75rem;
}

.stepActions {
  display: flex;
  flex-shrink: 0;
}
